import { render, staticRenderFns } from "./BsGrid.vue?vue&type=template&id=b1c03cd6&"
import script from "./BsGrid.vue?vue&type=script&lang=js&"
export * from "./BsGrid.vue?vue&type=script&lang=js&"
import style0 from "./BsGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports